var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeelingStrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0088D4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H32V32H8V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2827 18.5665C24.3406 18.0799 23.2714 17.8052 22.138 17.8052C20.0418 17.8052 18.1651 18.745 16.9062 20.2263",
    stroke: "#0088D4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6482 13.3541L14.6285 14.6584C15.178 15.3896 16.141 15.6755 17.0005 15.3626L19.5085 14.4499C20.6797 14.0237 21.215 12.6694 20.6516 11.5576L19.4694 9.22455C19.1743 8.64218 18.5108 8.34701 17.8806 8.51782L12.0622 10.0949C10.7865 10.4407 9.79381 11.4435 9.46095 12.7227C8.80217 15.2549 8.46875 17.8606 8.46875 20.477V25.2174C8.46875 25.9751 8.67636 26.7182 9.06894 27.3661C9.8203 28.6061 11.1649 29.3634 12.6147 29.3634L16.1914 29.3636C16.7573 29.3636 17.301 29.5699 17.735 29.9331C18.938 30.9403 20.4914 31.531 22.1859 31.531C25.9452 31.531 28.9998 28.4784 28.9998 24.7172C28.9998 23.5611 28.73 22.4707 28.2328 21.5124",
    stroke: "#0088D4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5098 24.2029V22.9496C17.5098 21.4885 16.9745 20.078 16.0051 18.9848C14.9247 17.7663 14.3281 16.1943 14.3281 14.5658V14.3591",
    stroke: "#0088D4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3515 26.9058C20.4485 29.0028 23.8483 29.0028 25.9453 26.9058",
    stroke: "#0088D4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97714 21.6718C9.04072 22.2393 8.46875 23.2547 8.46875 24.3496",
    stroke: "#0088D4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5162 13.0459L14.2246 13.1823C13.6329 13.4591 12.9278 13.2518 12.5801 12.6988",
    stroke: "#0088D4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7687 8.46926L25.1484 13.2111H27.7763L26.9824 17.0056L31.5309 11.3165H28.8808L29.9746 8.46926H26.7687Z",
    stroke: "#0088D4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelingStrong);
export default __webpack_public_path__ + "static/media/feeling-strong.55162afb061520f72821352baaa77961.svg";
export { ForwardRef as ReactComponent };